var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tooltip',{attrs:{"label":_vm.state,"type":_vm.stateType}},[_c('div',{staticClass:"block"},[_c('b-icon',{attrs:{"icon":_vm.stateIcon,"size":"is-small","type":_vm.stateType}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }